import React from 'react';

const Header = ({title, subtitle, className = "bg-ea_yellow text-gray-600"}) => {
    return (
        <div className={`w-full p-4 rounded-t-lg uppercase text-center ${className}`}>
            <div className="text-4xl font-bold mb-2">{title}</div>
            <div>{subtitle}</div>
        </div>
    )
}

export default Header;
